export default "__VITE_ASSET__1fdc1cbc__"